export default __webpack_public_path__ + "d04b459c457505e8839e93051ac72753.svg";